var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('h2',{staticClass:"text-center",domProps:{"textContent":_vm._s(_vm.$t('view.welcome.title'))}}),_c('p',{domProps:{"textContent":_vm._s(_vm.$t('view.welcome.p1'))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }